import React      from 'react';
import classnames from 'classnames';
import PropTypes  from 'prop-types';


import {
  boardLength as tooltipBoardLength,
  boardWidth as tooltipBoardWidth,
  copperInner as tooltipCopperInner,
  copperOuter as tooltipCopperOuter,
} from 'pu-data/Tooltips';

import Quantities        from 'pu-react/components/Quantities';
import NumberLayer       from 'pu-react/components/NumberLayer';
import MaterialThickness from 'pu-react/components/MaterialThickness';
import BoardSize         from 'pu-react/components/BoardSize';
import InstantQuote      from 'pu-react/components/InstantQuote';

import CopperWeight  from 'pu-react/components/CopperWeight';
import MinTraceSpace from 'pu-react/components/MinTraceSpace';
import Soldermask    from 'pu-react/components/Soldermask';
import Silkscreen    from 'pu-react/components/Silkscreen';

import UlCertification     from 'pu-react/components/UlCertification';
import DataCode            from 'pu-react/components/DataCode';
import PanelApproval       from 'pu-react/components/PanelApproval';
import SpecialInstruction  from 'pu-react/components/SpecialInstruction';
import RequiredInformation from 'pu-react/components/RequiredInformation';

import HiddenInput from 'pu-react/components/base/HiddenInput';

// import InstantQuote from './form/InstantQuote';
import MaterialTypeAndFinishPlating from './form/MaterialTypeAndFinishPlating'
import SmallestHoleSizeRange        from './form/SmallestHoleSizeRange';
import ArrayNeed                    from './form/ArrayNeed';
import SectionOptions               from './form/SectionOptions';
import Hidden                       from './form/Hidden';

import {
  cooperInner,
  cooperOuter,
  MinTrace,
  numberLayer,
  silkscreenColor,
  solderColor,
} from '../data/SelectOptions';

// import parametersCustomer from '../data/DefaultParametersCustomer';

const Parameters = (props) => {
  const { itemId, showSummary, onChangeParameter, parametersCustomer, parameters } = props
  const classFormSection = classnames('pcb-form-section', { 'd-none': showSummary });
  const groupName = `items[${props.itemId}][customer]`
  const propsPrm = {
    parameters: parametersCustomer,
    onChangeParameter,
    groupName,
  }

  const { errors } = props

  return (
    <div className={classFormSection}>
      <div className="row">
        <div className="col-md-12">
          <Quantities
            {...propsPrm}
            label="Board Quantities"
            groupName={`${groupName}[quantities]`}
            error={errors.quantities} />
        </div>
        <div className="col-6 col-lg-12 col-xl-6">
          <NumberLayer
            {...propsPrm}
            options={numberLayer} />
        </div>
        <div className="col-6 col-lg-12 col-xl-6">
          <MaterialThickness
            {...propsPrm}
            label="Board Thickness" />
        </div>

        <div className="col-12 col-lg-12 col-xl-12">
          <BoardSize
            {...propsPrm}
            label={null}
            labelLength="Board Length (in)"
            labelWidth="Board Width (in)"
            required={false}
            tooltip={null}
            tooltipLength={tooltipBoardLength}
            tooltipWidth={tooltipBoardWidth}
            errorBoardLength={errors.board_length}
            errorBoardWidth={errors.board_width} />
        </div>
        <div className="col-md-12">
          <div id="error_board_size" />
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <MaterialTypeAndFinishPlating {...propsPrm} />
        </div>

        <div className="col-md-12">
          <CopperWeight
            {...propsPrm}
            required
            label={null}
            labelInner="Inner Copper Wt"
            labelOuters="Outer Copper Wt"
            labelBottomInner={null}
            labelBottomOuters={null}
            tooltip={null}
            innerOptions={cooperInner}
            outerOptions={cooperOuter}
            tooltipInner={tooltipCopperInner}
            tooltipOuter={tooltipCopperOuter} />
        </div>
        <div className="col-md-6">
          <MinTraceSpace
            {...propsPrm}
            required
            label="Min. Trace Space"
            options={MinTrace} />
        </div>
        <div className="col-md-6">
          <SmallestHoleSizeRange
            {...propsPrm}
            className="smallest-hole-size"
            label="Smallest Hole Size" />
        </div>
        <div className="col-md-12">
          <Soldermask
            {...propsPrm}
            required
            colorOptions={solderColor} />
        </div>
        <div className="col-md-12">
          <Silkscreen
            {...propsPrm}
            required
            colorOptions={silkscreenColor} />
        </div>
      </div>

      <ArrayNeed {...propsPrm}
                 errors={errors} />

      <SectionOptions>
        <div className="row">
          <div className="col-md-6 col-lg-12 col-xl-7">
            <UlCertification {...propsPrm} />
          </div>
          <div className="col-md-6 col-lg-12 col-xl-5">
            <DataCode {...propsPrm} />
          </div>
          <div className="col-12">
            <PanelApproval {...propsPrm} />
          </div>
        </div>
      </SectionOptions>

      <SpecialInstruction {...propsPrm} />

      <div className="row">
        <div className="col-md-6">
          <RequiredInformation />
        </div>
        <div className="col-md-6">
          <InstantQuote 
            className="btn btn-block btn-blue"
            onClick={props.onRequestQuote} />
        </div>
      </div>
      <HiddenInput name="quantity" groupName={groupName} value="1" />
      <Hidden
        itemId={props.itemId}
        parameters={parameters}
        itemSelected={props.itemSelected}
        prefix_name={`items[${itemId}]`}
        variantId={props.variantId} />

    </div>
  );
};

Parameters.propTypes = {
  itemId: PropTypes.number.isRequired,
  showSummary: PropTypes.bool.isRequired,
  onChangeParameter: PropTypes.func.isRequired,
  parametersCustomer: PropTypes.object.isRequired,
  parameters: PropTypes.object.isRequired,
  onRequestQuote: PropTypes.func.isRequired,
}

export default Parameters
